module.exports = __webpack_public_path__ + "img/badgeRefusedLine.a7001e32.svg";